<template lang="pug">
  .main-container
    .upload(v-if="isNew")
      Upload Forms
    .manage(v-else)
      IQToolMiddlePaneHeader(:header="$t(`${baseTranslationPath}.header`)"
        :title="$t(`${baseTranslationPath}.title`)" @goToListPage="navigateAway()")
</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import Upload from './Upload.vue';

export default {
  name: 'ManageForms',
  components: {
    IQToolMiddlePaneHeader,
    Upload,
  },
  data() {
    return {
      baseTranslationPath: 'iq_tools_tab.forms_tab.manage',
      isNew: false,
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id === 'new') {
      this.isNew = true;
    }
  },

};
</script>
<style lang="scss" scoped>
@import "./../../../styles/aiq-variables.scss";

.upload {
  width: 100%;
  background-color: $aiq-bgc-list-item;
  margin-left: 4px;
  margin-right: 4px;
}
</style>